export function stream(payload) {
  return {
    type: "STREAM",
  };
}
export function startStream(data) {
  return {
    type: "START_STREAM",
    payload: {
      ...data,
    },
  };
}

export function leaveStream() {
  return {
    type: "LEAVE_STREAM",
  };
}
export function updatePos(pos) {
  return {
    type: "UPDATE_POS",
    pos,
  };
}
